export default __webpack_public_path__ + "static/media/glance-lines.57e3b4f9.svg";